import { Field, Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Post from "../../api/Post";
import Put from "../../api/Put";
import {
  ACCOUNT_ACTIVE_ALL,
  COMPANY_ALL_ACTIVE,
  COUNTRY_ACTIVE_ALL,
  LANGUAGE_ACTIVE_ALL,
  MARITAL_STATUS_ALL,
  MUNICIPIO_LIST,
  PACIENTERELACION_GET_ACTIVE,
  PACIENTES_ADD,
  PACIENTES_EDIT,
  PACIENTE_UPDATE,
  RELIGIONES_ALL,
  STATES_LIST,
  VALIDATE_QUALITAS,
} from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import Get from "../../api/Get";
import LoadingList from "../../loader/LoadingList";
import { Link, useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { FaInfo } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import es from "react-phone-input-2/lang/es.json";
import "react-phone-input-2/lib/style.css";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import Select from "react-select";
import { isDoctor } from "../../utils/isDoctor";
import { isConsultorio } from "../../utils/isConsultorio";

function FormPatient({ t, id, edit, isNew }) {
  //console.log(edit)
  const [gender, setGender] = useState("");
  const [dateOfBirthday, setDateOfBirthday] = useState(null);
  const [tipoSangre, setTipoSangre] = useState("");
  const { auth } = useContext(authContext);
  const [isGeneratedCita, setIsGenerateCita] = useState("editar");
  const history = useHistory();
  const [loading, setLoading] = useState(edit);
  const [phone, setPhone] = useState("");
  const [phone2, setPhone2] = useState("");

  const [accountsAll, setAccountsAll] = useState([]);
  const [companyOpt, setCompanyOpt] = useState([]);
  const [countryOpt, setCountryOpt] = useState([]);
  const [languageOpt, setLanguageOpt] = useState([]);
  const [maritalStatusOpt, setMaritalStatusOpt] = useState([]);
  const [religionOpt, setReligionOpt] = useState([]);
  const [show, setShow] = useState(false);
  const [partnerDefault, setPartnerDefault] = useState("");

  const [accountDefault, setAccountdefault] = useState(null);

  const [estadoAll, setEstadoAll] = useState([]);
  const [estadoOpt, setEstadoOpt] = useState([]);
  const [municipioAll, setMunicipioAll] = useState([]);
  const [municipioOpt, setMunicipioOpt] = useState([]);

  const [estadoDefault, setEstadoDefault] = useState(null);
  const [municipioDefault, setMunicipioDefault] = useState(null);
  const [paisDefault, setPaisDefault] = useState(null);
  const [tipoPacientes, setTipoPacientes] = useState([]);

  //error server
  const [showModalError, setShowModalError] = useState(false);
  const [errorServer, setErrorServer] = useState(null);
  const handleCloseServer = () => setShowModalError(false);

  const handleClose = () => setShow(false);

  const [validQualitas, setValidQualitas] = useState(true);
  const [
    openConfirmationQualitasPatients,
    setOpenConfirmationQualitasPatients,
  ] = useState(false);
  const [patientQSelected, setPatientQSelected] = useState(null);
  const [patientsQualitasList, setPatientsQualitasList] = useState([]);
  const [loadingQualitas, setLoadingQualitas] = useState(false);
  const [openConfirmationQualitas, setOpenConfirmationQualitas] =
    useState(false);
  const [checkQualitas, setCheckQualitas] = useState(false);
  const [lastName, setLastName] = useState("");
  const [seccondSurname, setSeccondSurname] = useState("");
  const [polizaQualitas, setPolizaQualitas] = useState(null);
  const [errorPoliza, setErrorPoliza] = useState(false);
  const [objQualitas, setObjQualitas] = useState({
    name: "",
    middleName: "",
    lastName: "",
    seccondSurname: "",
    externalId: "",
    dateOfBirthday: "",
  });
  //coberturas
  const [coberturasOpt, setCoberturasOpt] = useState([]);
  const [coberturasDefault, setCoberturaDefault] = useState("");
  const [subCoberturasOpt, setSubCoberturasOpt] = useState([]);
  const [subCoberturasDefault, setSubCoberturasDefault] = useState("");

  const [initialValues, setInitialValues] = useState({
    id: "",
    name: "",
    middleName: "",
    seccondSurname: "",
    lastName: "",
    gender: "",
    dateOfBirthday: "",
    maritalStatus: "",
    nationality: "",
    phoneNumber: "",
    phoneNumber2: "",
    email: "",
    country: "",
    religion: "",
    donadorOrganos: "No",
    bloodType: "",
    occupation: "",
    language: "",
    address: "",
    allergies: "",
    account: "",
    company: "",
    medicalHistory: "",
    externalId: "",
    cp: "",
    municipio: "",
    state: "",
    patientRelationship: "",
    polizaQualitas: polizaQualitas,
  });

  const shemaValidate = Yup.object().shape({
    name: Yup.string().required(t("Camporequerido")),
    lastName: Yup.string().required(t("Camporequerido")),
    seccondSurname: Yup.string().when("lastName", {
      is: accountDefault?.label?.toLowerCase().includes("qualitas") === true,
      then: Yup.string().required(t("Camporequerido")),
      otherwise: Yup.string().notRequired(),
    }),
    patientRelationship: Yup.string().required(t("Camporequerido")),
    gender: Yup.string().required(t("Camporequerido")),
    dateOfBirthday: Yup.string().required(t("Camporequerido")),
    // nationality: Yup.string()
    //   .required(t('Camporequerido')),
    phoneNumber: Yup.string()
      .required(t("Camporequerido"))
      .min(12, "Campo inválido")
      .max(12, "Campo inválido"),
    /*phoneNumber2: Yup.string()
      .required(t("Camporequerido"))
      .min(12, "Campo inválido")
      .max(12, "Campo inválido"),*/
    email: Yup.string()
      .email(t("Correoinvalido"))
      .required(t("Camporequerido")),
    maritalStatus: Yup.string().required(t("Camporequerido")),
    country: Yup.string().required(t("Camporequerido")),
    cp: Yup.string().required(t("Camporequerido")),
    municipio: Yup.string().required(t("Camporequerido")),
    state: Yup.string().required(t("Camporequerido")),
    //religion: Yup.string().required(t("Camporequerido")),
    // bloodType: Yup.string()
    //   .required(t('Camporequerido')),
    // occupation: Yup.string()
    //   .required(t('Camporequerido')),
    language: Yup.string().required(t("Camporequerido")),
    // address: Yup.string()
    //   .required(t('Camporequerido')),
    // allergies: Yup.string()
    //   .required(t('Camporequerido')),
    account: Yup.string().required(t("Camporequerido")),
    company: Yup.string().required(t("Camporequerido")),
  });

  useEffect(() => {
    Get({ url: ACCOUNT_ACTIVE_ALL, access_token: auth.data.access_token })
      .then((response) => {
        setAccountsAll(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: COMPANY_ALL_ACTIVE, access_token: auth.data.access_token })
      .then((response) => {
        setCompanyOpt(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: COUNTRY_ACTIVE_ALL, noToken: true })
      .then((response) => {
        setCountryOpt(
          response.data.data.response.map((el) => ({
            label: el.name,
            value: el.id,
          }))
        );
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: LANGUAGE_ACTIVE_ALL, access_token: auth.data.access_token })
      .then((response) => {
        setLanguageOpt(response.data);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: MARITAL_STATUS_ALL, access_token: auth.data.access_token })
      .then((response) => {
        setMaritalStatusOpt(response.data.data.response.content);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: RELIGIONES_ALL, access_token: auth.data.access_token })
      .then((response) => {
        setReligionOpt(response.data.data.response.content);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({
      url: PACIENTERELACION_GET_ACTIVE,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        setTipoPacientes(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
  }, []);

  //si cambia el pais
  const [idCountry, setIdCountry] = useState(null);
  useEffect(() => {
    if (idCountry) {
      Get({
        url: `${STATES_LIST}/${idCountry}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setEstadoOpt(
            response.data.data.response.map((el) => ({
              label: el.name,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setEstadoOpt([]);
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    } else {
      setEstadoOpt([]);
    }
  }, [idCountry]);

  //si cambia el estado
  const [idEstado, setIdEstado] = useState(null);
  useEffect(() => {
    if (idEstado) {
      Get({
        url: `${MUNICIPIO_LIST}/${idEstado}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          //console.log(response)
          setMunicipioOpt(
            response.data.data.response.map((el) => ({
              label: el.dsMunDel,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setMunicipioOpt([]);
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    } else {
      setMunicipioOpt([]);
    }
  }, [idEstado]);

  useEffect(() => {
    setEstadoOpt(
      estadoAll.filter((el) => el.country?.id === initialValues.country)
    );
    setMunicipioOpt(
      municipioAll.filter((el) => el.state?.id === initialValues.state)
    );
  }, [initialValues, municipioAll, estadoAll]);

  //si cambia el account para q sepa cual es el partner==="cliente corporativo"
  useEffect(() => {
    if (accountDefault) {
      let itemsF = accountsAll.filter((el) => el.id === accountDefault.value);
      if (itemsF.length) {
        setPartnerDefault(itemsF[0].partner.name);
      }
    }
  }, [accountDefault]);

  //buscar para editar el paciente
  useEffect(() => {
    if (id) {
      Get({
        url: `${PACIENTES_EDIT}/${id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          //sconsole.log(response)
          let entity = {
            id: response.data.id,
            name: response.data.name ? response.data.name : "",
            middleName: response.data.middleName
              ? response.data.middleName
              : "",
            seccondSurname: response.data.seccondSurname
              ? response.data.seccondSurname
              : "",
            lastName: response.data.lastName ? response.data.lastName : "",
            gender: response.data.gender ? response.data.gender : "",
            dateOfBirthday: response.data.dateOfBirthday
              ? new Date(moment(response.data.dateOfBirthday, "DD-MM-YYYY"))
              : "",
            maritalStatus: response.data.maritalStatus
              ? response.data.maritalStatus.id
              : "",
            nationality: response.data.nationality
              ? response.data.nationality
              : "",
            phoneNumber: response.data.phoneNumber
              ? response.data.phoneNumber
              : "",
            phoneNumber2: response.data.phoneNumber2
              ? response.data.phoneNumber2
              : "",
            email: response.data.email,
            country: response.data.country ? response.data.country.id : "",
            religion: response.data.religion ? response.data.religion.id : "",
            donadorOrganos: response.data.donadorOrganos ? response.data.donadorOrganos : "No",
            bloodType: response.data.bloodType ? response.data.bloodType : "",
            occupation: response.data.occupation
              ? response.data.occupation
              : "",
            language: response.data.language ? response.data.language.id : "",
            address: response.data.address ? response.data.address : "",
            allergies: response.data.allergies ? response.data.allergies : "",
            account: response.data.account ? response.data.account.id : "",
            company: response.data.company ? response.data.company.id : "",
            medicalHistory: response.data.medicalHistory
              ? response.data.medicalHistory
              : "",
            externalId: response.data.externalId
              ? response.data.externalId
              : "",
            cp: response.data.cp ? response.data.cp : "",
            municipio: response.data.municipio
              ? response.data.municipio.id
              : "",
            state: response.data.state ? response.data.state.id : "",
            patientRelationship: response.data.patientRelationship
              ? response.data.patientRelationship.id
              : "",
          };
          setPhone(response.data.phoneNumber);
          setPhone2(response.data.phoneNumber2);
          setPartnerDefault(
            response.data.account ? response.data.account.partner.name : ""
          );
          setAccountdefault({
            label: response.data.account.name,
            value: response.data.account.id,
          });
          if (response.data.country) {
            setIdCountry(response.data.country?.id);
            setPaisDefault({
              label: response.data.country.name,
              value: response.data.country.id,
            });
          }
          if (response.data.state) {
            setEstadoDefault({
              label: response.data.state.name,
              value: response.data.state.id,
            });
            setIdEstado(response.data.state.id);
          }
          if (response.data.municipio) {
            setMunicipioDefault({
              label: response.data.municipio.dsMunDel,
              value: response.data.municipio.id,
            });
          }
          setTipoSangre(response.data.bloodType);
          setGender(response.data.gender);
          setDateOfBirthday(
            response.data.dateOfBirthday
              ? new Date(moment(response.data.dateOfBirthday, "DD-MM-YYYY"))
              : null
          );
          setInitialValues(entity);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  const generarCita = (valor) => {
    setIsGenerateCita(valor);
  };

  useEffect(() => {
    if (checkQualitas) {
      async function checkQualitasAPI() {
        setLoadingQualitas(true);
        try {
          const data = {
            lastName: lastName,
            seccondSurname: seccondSurname,
          };
          const response = await Post({
            url: VALIDATE_QUALITAS,
            data: data,
            access_token: auth.data.access_token,
            header: true,
          });
          setLoadingQualitas(false);
          if (response.data.state) {
            console.log(response.data.data);
            if (response.data.data.response.length > 1) {
              setPatientsQualitasList(response.data.data.response);
              setOpenConfirmationQualitasPatients(true);
            } else if (response.data.data.response.length === 1) {
              const patientQ = response.data.data.response[0];
              setCoberturasOpt(patientQ?.coberturaDTOS ?? []);
              setPolizaQualitas(patientQ?.polizaQualitas ?? null);
              setOpenConfirmationQualitas(true);
              setValidQualitas(true);
              setInitialValues((prev) => ({
                ...prev,
                id: patientQ.id,
                account: accountDefault.value,
                name: patientQ.name,
                middleName: patientQ.middleName,
                seccondSurname: patientQ.seccondSurname,
                lastName: patientQ.lastName,
                externalId: patientQ.externalId,
                email: patientQ?.polizaQualitas?.correoAsegurado ?? "",
                dateOfBirthday: patientQ.dateOfBirthday
                  ? new Date(moment(patientQ.dateOfBirthday, "DD-MM-YYYY"))
                  : "",
                polizaQualitas: patientQ?.polizaQualitas ?? null,
              }));
              setDateOfBirthday(
                patientQ.dateOfBirthday
                  ? new Date(moment(patientQ.dateOfBirthday, "DD-MM-YYYY"))
                  : null
              );
            } else {
              setOpenConfirmationQualitas(true);
              setValidQualitas(false);
              setInitialValues((prev) => ({
                ...prev,
                id: "",
                name: "",
                middleName: "",
                externalId: "",
                dateOfBirthday: "",
                email: "",
                polizaQualitas: null,
              }));
              setDateOfBirthday(null);
            }
          } else {
            setOpenConfirmationQualitas(true);
            setValidQualitas(false);
            setInitialValues((prev) => ({
              ...prev,
              id: "",
              name: "",
              middleName: "",
              externalId: "",
              dateOfBirthday: "",
              email: "",
              polizaQualitas: null,
            }));
            setDateOfBirthday(null);
          }
        } catch (error) {
          setValidQualitas(false);
          setLoadingQualitas(false);
        }
      }
      checkQualitasAPI();
      setCheckQualitas(false);
    }
  }, [lastName, seccondSurname, checkQualitas]);

  //console.log(initialValues);
  return (
    <Row>
      {id && loading ? (
        <LoadingList texto={t("cargando_datos")} />
      ) : (
        <Col>
          <Formik
            initialValues={initialValues}
            validationSchema={shemaValidate}
            enableReinitialize
            onSubmit={(values, { setSubmitting, setFieldValue }) => {
              //setSubmiting(true)
              //console.log(values)
              let d = {
                id: values.id,
                account: { id: values.account },
                address: values.address,
                allergies: values.allergies,
                bloodType: values.bloodType,
                company: { id: values.company },
                country: { id: values.country },
                dateOfBirthday: moment(values.dateOfBirthday).format(
                  "DD-MM-YYYY"
                ),
                email: values.email,
                gender: values.gender,
                language: { id: values.language },
                lastName: values.lastName,
                maritalStatus: { id: values.maritalStatus },
                medicalHistory: values.medicalHistory,
                name: values.name,
                middleName: values.middleName,
                seccondSurname: values.seccondSurname,
                nationality: values.nationality,
                isNewPatient: isNew && !values.id ? isNew : false,
                occupation: values.occupation,
                phoneNumber: values.phoneNumber,
                //phoneNumber2: values.phoneNumber2,
                phoneNumber2: values.phoneNumber2 ? values.phoneNumber2 : '',
                //religion: values.religion && values.religion.trim() ? { id: values.religion } : null,
                religion: typeof values.religion === 'string' && values.religion.trim() ? { id: values.religion } : null,
                donadorOrganos: values.donadorOrganos,
                password: "123456",
                autoagendamiento: isGeneratedCita === "automatico",
                externalId: values.externalId,
                cp: values.cp,
                municipio: { id: values.municipio },
                state: { id: values.state },
                patientRelationship: { id: values.patientRelationship },
                polizaQualitas: values.polizaQualitas
                  ? {
                    ...values.polizaQualitas,
                    coverage: coberturasDefault,
                    subCoverage: subCoberturasDefault,
                  }
                  : null,
              };
              //console.log(d)

              if ((edit && id) || values.id) {
                Put({
                  url: PACIENTE_UPDATE,
                  data: d,
                  access_token: auth.data.access_token,
                  header: true,
                })
                  .then((response) => {
                    //console.log(response)
                    setSubmitting(false);
                    if (response) {
                      if (isGeneratedCita === "manual") {
                        history.replace(
                          `/admin/create-appointment/${response.data.id}`
                        );
                      } else if (isGeneratedCita === "automatico") {
                        setShow(true);
                        setTimeout(() => {
                          setShow(false);
                          if (
                            isDoctor(auth.data.role) ||
                            isConsultorio(auth.data.role)
                          ) {
                            history.replace(`/admin/doctors/patients`);
                          } else {
                            history.replace("/admin/patients");
                          }
                        }, 4000);
                      } else {
                        if (
                          isDoctor(auth.data.role) ||
                          isConsultorio(auth.data.role)
                        ) {
                          history.replace(`/admin/doctors/patients`);
                        } else {
                          history.replace("/admin/patients");
                        }
                      }
                    }
                  })
                  .catch((error) => {
                    setSubmitting(false);
                    setShowModalError(true);
                    if (error.response) {
                      setErrorServer(error.response);
                    }
                  });
              } else {
                Post({
                  url: PACIENTES_ADD,
                  data: d,
                  access_token: auth.data.access_token,
                  header: true,
                })
                  .then((response) => {
                    console.log(response);
                    setSubmitting(false);
                    if (response) {
                      if (isGeneratedCita === "manual") {
                        history.replace(
                          `/admin/create-appointment/${response.data.data.id}`
                        );
                      } else if (isGeneratedCita === "automatico") {
                        setShow(true);
                        setTimeout(() => {
                          setShow(false);
                          if (
                            isDoctor(auth.data.role) ||
                            isConsultorio(auth.data.role)
                          ) {
                            history.replace(`/admin/doctors/patients`);
                          } else {
                            history.replace("/admin/patients");
                          }
                        }, 4000);
                      } else {
                        if (
                          isDoctor(auth.data.role) ||
                          isConsultorio(auth.data.role)
                        ) {
                          history.replace(`/admin/doctors/patients`);
                        } else {
                          history.replace("/admin/patients");
                        }
                      }
                    }
                  })
                  .catch((error) => {
                    setSubmitting(false);
                    setShowModalError(true);
                    if (error.response) {
                      setErrorServer(error.response);
                    }
                  });
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldError,
            }) => (
              <Form onSubmit={handleSubmit} className="mt-3">
                {loadingQualitas && <LoadingList texto="Validando paciente" />}
                {isSubmitting && <LoadingList texto="Procesando petición" />}
                <input type="hidden" name="id" value={values.id} />
                <Card className="shadow-1">
                  <Card.Body>
                    <h4 className="text-color-4">{t("Datosgenerales")}</h4>
                    <Row>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Nombre")} <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase ${errors.name && "error"
                              }`}
                            name="name"
                            onChange={(e) => {
                              setFieldValue(
                                "name",
                                e.target.value.toUpperCase()
                              );
                            }}
                          //disabled={objQualitas.name}
                          />
                          {errors.name && (
                            <div className="invalid-feedback d-block">
                              {errors.name}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Segundo nombre
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase`}
                            name="middleName"
                            onChange={(e) => {
                              setFieldValue(
                                "middleName",
                                e.target.value.toUpperCase()
                              );
                            }}
                          //disabled={objQualitas.middleName}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Primer Apellido{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase ${errors.lastName && "error"
                              }`}
                            name="lastName"
                            onChange={(e) => {
                              setFieldValue(
                                "lastName",
                                e.target.value.toUpperCase()
                              );
                              setLastName(e.target.value.toUpperCase());
                            }}
                            onBlur={(e) => {
                              if (
                                accountDefault?.label
                                  .toLowerCase()
                                  .includes("qualitas") === true
                              ) {
                                setCheckQualitas(true);
                              }
                            }}
                          //disabled={objQualitas.lastName}
                          />
                          {errors.lastName && (
                            <div className="invalid-feedback d-block">
                              {errors.lastName}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Segundo Apellido
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase ${errors.seccondSurname && "error"
                              }`}
                            name="seccondSurname"
                            onChange={(e) => {
                              setFieldValue(
                                "seccondSurname",
                                e.target.value.toUpperCase()
                              );
                              setSeccondSurname(e.target.value.toUpperCase());
                            }}
                            onBlur={(e) => {
                              if (
                                accountDefault?.label
                                  .toLowerCase()
                                  .includes("qualitas") === true
                              ) {
                                setCheckQualitas(true);
                              }
                            }}
                          //disabled={objQualitas.seccondSurname}
                          />
                          {errors.seccondSurname && (
                            <div className="invalid-feedback d-block">
                              {errors.seccondSurname}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Tipo <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${errors.patientRelationship && "error"
                              }`}
                            name="patientRelationship"
                          >
                            <option value="">Seleccionar</option>
                            {tipoPacientes.map((item, i) => (
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </Field>
                          {errors.patientRelationship && (
                            <div className="invalid-feedback d-block">
                              {errors.patientRelationship}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("cuenta_cliente_corporativo")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className="input-form"
                            options={accountsAll.map((e) => ({
                              label: e.name,
                              value: e.id,
                            }))}
                            defaultValue={accountDefault}
                            value={accountDefault}
                            onChange={(e) => {
                              setAccountdefault(e);
                              setFieldValue("account", e.value);

                              if (
                                e?.label.toLowerCase().includes("qualitas") ===
                                true
                              ) {
                                setCheckQualitas(true);
                              } else {
                                setObjQualitas({
                                  name: "",
                                  middleName: "",
                                  lastName: "",
                                  seccondSurname: "",
                                  externalId: "",
                                  dateOfBirthday: "",
                                });
                                setValidQualitas(true);
                              }
                            }}
                            menuPlacement="top"
                          />
                          {errors.account && (
                            <div className="invalid-feedback d-block">
                              {errors.account}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Cliente corporativo{" "}
                          </Form.Label>
                          <div className="form-control input-form align-center">
                            {partnerDefault}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("sexo")} <span className="text-danger">*</span>
                          </Form.Label>
                          <ul className="mb-0 list-inline list-form">
                            <li
                              className={`${gender === "Female" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setGender("Female");
                                setFieldValue("gender", "Female");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                {t("Femenino")}
                              </span>
                            </li>
                            <li
                              className={`${gender === "Male" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setGender("Male");
                                setFieldValue("gender", "Male");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                {t("Masculino")}
                              </span>
                            </li>
                          </ul>
                          {errors.gender && (
                            <div className="invalid-feedback d-block">
                              {errors.gender}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary d-block">
                            {t("fecha_nacimiento")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <DatePicker
                            className={`form-control input-form w-100 ${errors.dateOfBirthday && "error"
                              }`}
                            selected={dateOfBirthday}
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            onChange={(date) => {
                              if (date === null) {
                                setDateOfBirthday(null);
                                setFieldValue("dateOfBirthday", "");
                              } else {
                                setDateOfBirthday(date);
                                setFieldValue("dateOfBirthday", date);
                              }
                            }}
                          />
                          {errors.dateOfBirthday && (
                            <div className="invalid-feedback d-block">
                              {errors.dateOfBirthday}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Nacionalidad")}
                          </Form.Label>
                          <div className="mt-3">
                            <label className="mr-5 text-color-input">
                              {t("Mexicana")}
                              <Field
                                type="radio"
                                name="nationality"
                                value="Mexicana"
                                className="ml-3 radio-form"
                              />
                            </label>
                            <label className="mr-5 text-color-input">
                              {t("Extranjera")}
                              <Field
                                type="radio"
                                name="nationality"
                                value="Extranjera"
                                className="ml-3 radio-form"
                              />
                            </label>
                          </div>
                          {errors.nationality && (
                            <div className="invalid-feedback d-block">
                              {errors.nationality}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Estadocivil")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${errors.maritalStatus && "error"
                              }`}
                            name="maritalStatus"
                          >
                            <option value="">{t("Seleccionar")}</option>
                            {maritalStatusOpt.map((item, i) => (
                              <option value={item.id} key={i}>
                                {item.name}
                              </option>
                            ))}
                          </Field>
                          {errors.maritalStatus && (
                            <div className="invalid-feedback d-block">
                              {errors.maritalStatus}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="shadow-1 my-5">
                  <Card.Body>
                    <h4 className="text-color-4">{t("Expediente")}</h4>
                    <Row>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            No. póliza
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${errors.externalId && "error"
                              }`}
                            name="externalId"
                          //disabled={objQualitas.externalId}
                          />
                          <Form.Text muted>
                            Este campo no es obligatorio
                          </Form.Text>
                          {errors.externalId && (
                            <div className="invalid-feedback d-block">
                              {errors.externalId}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Telefono")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <PhoneInput
                            inputClass={`form-control input-form ${errors.phoneNumber && "error"
                              } w-100`}
                            country={"mx"}
                            countryCodeEditable={false}
                            enableSearch={true}
                            preferredCountries={["mx", "co"]}
                            disableSearchIcon={true}
                            localization={es}
                            value={phone}
                            onChange={(phone, country, e, formattedValue) => {
                              setPhone(phone);
                              setFieldValue("phoneNumber", phone);
                              let validNumber =
                                country.format.match(/\./g).length;
                              if (phone.length !== validNumber) {
                                setFieldError("phoneNumber", "Campo inválido");
                              } else if (phone.length === validNumber) {
                                setFieldValue("phoneNumber", phone, true);
                              }
                            }}
                          />
                          {errors.phoneNumber && (
                            <div className="invalid-feedback d-block">
                              {errors.phoneNumber}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Teléfono alterno{" "}
                          </Form.Label>
                          <PhoneInput
                            inputClass={`form-control input-form ${errors.phoneNumber2 && "error"
                              } w-100`}
                            country={"mx"}
                            countryCodeEditable={false}
                            enableSearch={true}
                            preferredCountries={["mx", "co"]}
                            disableSearchIcon={true}
                            localization={es}
                            value={phone2}
                            onChange={(phone, country, e, formattedValue) => {
                              setPhone2(phone);
                              setFieldValue("phoneNumber2", phone);
                              let validNumber =
                                country.format.match(/\./g).length;
                              if (phone.length !== validNumber) {
                                setFieldError("phoneNumber2", "Campo inválido");
                              } else if (phone.length === validNumber) {
                                setFieldValue("phoneNumber2", phone, true);
                              }
                            }}
                          />
                          {errors.phoneNumber2 && (
                            <div className="invalid-feedback d-block">
                              {errors.phoneNumber2}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Correoelectronico")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${errors.email && "error"
                              }`}
                            name="email"
                          />
                          {errors.email && (
                            <div className="invalid-feedback d-block">
                              {errors.email}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Religion")}{" "}
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${errors.religion && "error"
                              }`}
                            name="religion"
                          >
                            <option value="">{t("Seleccionar")}</option>
                            {religionOpt.map((item, i) => (
                              <option value={item.id} key={i}>
                                {item.name}
                              </option>
                            ))}
                          </Field>
                          {errors.religion && (
                            <div className="invalid-feedback d-block">
                              {errors.religion}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
<Form.Group>
    <Form.Label className="font-weight-bold-600 text-secondary">
        Donador de órganos <span className="text-danger">*</span>
    </Form.Label>
    <Select
        className={`input-form ${errors.donadorOrganos && "error"}`}
        options={[
            { value: 'No', label: 'No' },
            { value: 'Si', label: 'Si' }
        ]}
        defaultValue={{ value: initialValues.donadorOrganos, label: initialValues.donadorOrganos }}
        onChange={(value) => {
            setFieldValue("donadorOrganos", value.value);
        }}
        placeholder="Escoger opción"
    />
    {errors.donadorOrganos && (
        <div className="invalid-feedback d-block">
            {errors.donadorOrganos}
        </div>
    )}
</Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Código Postal <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${errors.cp && "error"
                              }`}
                            name="cp"
                          />
                          {errors.cp && (
                            <div className="invalid-feedback d-block">
                              {errors.cp}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            País <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className={`input-form ${errors.country && "error"
                              }`}
                            options={countryOpt}
                            defaultValue={paisDefault}
                            value={paisDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setPaisDefault(value);
                              setFieldValue("country", value.value);
                              setMunicipioOpt([]);
                              setFieldValue("municipio", "");
                              setMunicipioDefault(null);
                              setFieldValue("state", "");
                              setEstadoDefault(null);
                              setIdCountry(value.value);
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.country && (
                            <div className="invalid-feedback d-block">
                              {errors.country}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Estado <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className={`input-form ${errors.state && "error"}`}
                            options={estadoOpt}
                            defaultValue={estadoDefault}
                            value={estadoDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setEstadoDefault(value);
                              setFieldValue("state", value.value);
                              setFieldValue("municipio", "");
                              setMunicipioDefault(null);
                              setMunicipioOpt([]);
                              setIdEstado(value.value);
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.state && (
                            <div className="invalid-feedback d-block">
                              {errors.state}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Municipio <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className={`input-form ${errors.municipio && "error"
                              }`}
                            options={municipioOpt}
                            defaultValue={municipioDefault}
                            value={municipioDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setMunicipioDefault(value);
                              setFieldValue("municipio", value.value);
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.municipio && (
                            <div className="invalid-feedback d-block">
                              {errors.municipio}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Tiposangre")}
                          </Form.Label>
                          <ul className="mb-0 list-inline list-form">
                            <li
                              className={`${tipoSangre === "O-" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("O-");
                                setFieldValue("bloodType", "O-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                O-
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "O+" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("O+");
                                setFieldValue("bloodType", "O+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                O+
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "A-" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("A-");
                                setFieldValue("bloodType", "A-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                A-
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "A+" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("A+");
                                setFieldValue("bloodType", "A+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                A+
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "AB-" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("AB-");
                                setFieldValue("bloodType", "AB-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                AB-
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "AB+" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("AB+");
                                setFieldValue("bloodType", "AB+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                AB+
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "B+" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("B+");
                                setFieldValue("bloodType", "B+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                B+
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "B-" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("B-");
                                setFieldValue("bloodType", "B-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                B-
                              </span>
                            </li>
                            <li
                              className={`${tipoSangre === "desconocido" && "active"
                                } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("desconocido");
                                setFieldValue("bloodType", "desconocido");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                {t("Desconocido")}
                              </span>
                            </li>
                          </ul>
                          {errors.bloodType && (
                            <div className="invalid-feedback d-block">
                              {errors.bloodType}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("ocupacion")}
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${errors.occupation && "error"
                              }`}
                            name="occupation"
                          />
                          {errors.occupation && (
                            <div className="invalid-feedback d-block">
                              {errors.occupation}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Idioma")} <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${errors.language && "error"
                              }`}
                            name="language"
                          >
                            <option value="">{t("Seleccionar")}</option>
                            {languageOpt.map((item, i) => (
                              <option value={item.id} key={i}>
                                {item.name}
                              </option>
                            ))}
                          </Field>
                          {errors.language && (
                            <div className="invalid-feedback d-block">
                              {errors.language}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("direccion")}
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${errors.address && "error"
                              }`}
                            name="address"
                          />
                          {errors.address && (
                            <div className="invalid-feedback d-block">
                              {errors.address}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("alergias")}
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${errors.allergies && "error"
                              }`}
                            name="allergies"
                          />
                          {errors.allergies && (
                            <div className="invalid-feedback d-block">
                              {errors.allergies}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("historia_medica")}
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${errors.medicalHistory && "error"
                              }`}
                            name="medicalHistory"
                          />
                          {errors.medicalHistory && (
                            <div className="invalid-feedback d-block">
                              {errors.medicalHistory}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("compania")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${errors.company && "error"
                              }`}
                            name="company"
                          >
                            <option value="">{t("Seleccionar")}</option>
                            {companyOpt.map((item, i) => (
                              <option value={item.id} key={i}>
                                {item.name}
                              </option>
                            ))}
                          </Field>
                          {errors.company && (
                            <div className="invalid-feedback d-block">
                              {errors.company}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      {validQualitas && (
                        <Col xs="12" md="6">
                          <Form.Group>
                            <Form.Label className="font-weight-bold-600 text-secondary">
                              {t("generar_cita")}
                            </Form.Label>
                            <div className="mt-3">
                              <label className="mr-5 text-color-input">
                                Manual
                                <input
                                  name="generarCita"
                                  type="radio"
                                  className="ml-3 radio-form"
                                  onChange={(e) => generarCita("manual")}
                                />
                              </label>
                              <label className="mr-5 text-color-input">
                                Autoagendamiento
                                <input
                                  name="generarCita"
                                  type="radio"
                                  className="ml-3 radio-form"
                                  onChange={(e) => generarCita("automatico")}
                                />
                              </label>
                            </div>
                          </Form.Group>
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </Card>

                <Row>
                  <Col className="text-right">
                    <Link
                      to={
                        isDoctor(auth.data.role) ||
                          isConsultorio(auth.data.role)
                          ? "/admin/doctors/patients"
                          : "/admin/patients"
                      }
                      className="btn btn-danger cancelar-buttom"
                    >
                      Cancelar
                    </Link>{" "}
                    <Button
                      variant="outline-success"
                      className="ok-buttom"
                      type="submit"
                    >
                      Aceptar
                    </Button>{" "}
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      )}

      <Modal show={show} onHide={handleClose} centered className="border-0">
        <Modal.Body>
          <div className="text-center position-relative overflow-hidden h-100p">
            <div className="text-center">
              <span className="d-block">
                <FaInfo className="text-info" />
              </span>
              <h5 className="mt-1 mb-0">
                Se le ha enviado el link para su autoagendamiento
              </h5>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={openConfirmationQualitas}
        centered
        className="border-0"
        backdrop={"static"}
        keyboard={false}
      >
        <Modal.Body>
          {validQualitas ? (
            <h6>
              La póliza se ha validado exitosamente. Por favor seleccione su
              cobertura y subcobertura
            </h6>
          ) : (
            <div className="text-center">
              <span>
                <FaInfo className="text-info" />
              </span>
              <h5 className="mt-1 mb-2">Usuario inactivo</h5>
              <Button
                variant="outline-secondary"
                onClick={() => setOpenConfirmationQualitas(false)}
              >
                Cerrar
              </Button>
            </div>
          )}
          {errorPoliza && (
            <span className="text-danger d-block">
              Los campos cobertura y subcobertura son requeridos
            </span>
          )}
          {validQualitas && (
            <>
              <div className="d-flex flex-column">
                <div className="mb-2">
                  <label className="mb-1 d-block">Cobertura</label>
                  <select
                    className="input-table"
                    value={coberturasDefault}
                    onChange={(e) => {
                      setCoberturaDefault(e.target.value);
                      setSubCoberturasDefault("");
                      if (e.target.value) {
                        setSubCoberturasOpt(
                          coberturasOpt.find(
                            (it) => it.codCobertura === e.target.value
                          ).subCoberturas
                        );
                      } else {
                        setSubCoberturasOpt([]);
                      }
                    }}
                  >
                    <option value="">Seleccionar</option>
                    {coberturasOpt.map((item, i) => (
                      <option key={`cobeetura-${i}`} value={item.codCobertura}>
                        {item.nomCobertura}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="mb-1 d-block">Subcobertura</label>
                  <select
                    className="input-table"
                    value={subCoberturasDefault}
                    onChange={(e) => {
                      setSubCoberturasDefault(e.target.value);
                    }}
                  >
                    <option value="">Seleccionar</option>
                    {subCoberturasOpt.map((item, i) => (
                      <option
                        key={`subcobeetura-${i}`}
                        value={item.numSubCobertura}
                      >
                        {item.nomSubCobertura}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="d-flex mt-3">
                <div className="mr-1">
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => {
                      if (
                        coberturasDefault === "" ||
                        subCoberturasDefault === ""
                      ) {
                        setErrorPoliza(true);
                      } else {
                        setErrorPoliza(false);
                        setOpenConfirmationQualitas(false);
                      }
                    }}
                  >
                    Aceptar
                  </Button>
                </div>
                <div>
                  <Button
                    variant="outline-danger"
                    type="button"
                    onClick={() => {
                      setPolizaQualitas(null);
                      setOpenConfirmationQualitas(false);
                      setErrorPoliza(false);
                      setInitialValues((prev) => ({
                        ...prev,
                        id: "",
                        account: "",
                        name: "",
                        middleName: "",
                        seccondSurname: prev.seccondSurname,
                        lastName: prev.lastName,
                        externalId: "",
                        dateOfBirthday: "",
                        email: "",
                        polizaQualitas: null,
                      }));
                    }}
                  >
                    Cancelar
                  </Button>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={openConfirmationQualitasPatients}
        centered
        className="border-0"
        backdrop={"static"}
        keyboard={false}
      >
        <Modal.Body className="">
          <h6>Seleccionar paciente</h6>
          {patientsQualitasList.map((p) => (
            <div
              className={`border cursor-pointer mb-2 shadow-sm p-3 ${patientQSelected?.id === p.id ? "border-primary" : ""
                }`}
              key={p.id}
              onClick={(e) => setPatientQSelected(p)}
            >
              <div className="d-flex justify-content-between">
                <div className="mr-5">
                  <span className="d-block">
                    {`${p.name} ${p?.middleName ?? ""} ${p?.lastName ?? ""} ${p?.seccondSurname ?? ""
                      }`}
                  </span>
                  <span>{p.dateOfBirthday}</span>
                </div>
                <div>
                  <span className="badge badge-secondary d-block">
                    {p.externalId}
                  </span>
                  <span className="font-size-07rem">
                    {p?.polizaQualitas?.dependiente}
                  </span>
                </div>
              </div>
            </div>
          ))}
          <div className="d-flex mt-3">
            <div className="mr-1">
              <Button
                type="button"
                variant="primary"
                disabled={patientQSelected === null}
                onClick={() => {
                  setCoberturasOpt(patientQSelected?.coberturaDTOS ?? []);
                  setPolizaQualitas(patientQSelected?.polizaQualitas ?? null);
                  setOpenConfirmationQualitas(true);
                  setValidQualitas(true);
                  setInitialValues((prev) => ({
                    ...prev,
                    id: patientQSelected.id,
                    account: accountDefault.value,
                    name: patientQSelected.name,
                    middleName: patientQSelected.middleName,
                    seccondSurname: patientQSelected.seccondSurname,
                    lastName: patientQSelected.lastName,
                    externalId: patientQSelected.externalId,
                    email:
                      patientQSelected?.polizaQualitas?.correoAsegurado ?? "",
                    dateOfBirthday: patientQSelected.dateOfBirthday
                      ? new Date(
                        moment(patientQSelected.dateOfBirthday, "DD-MM-YYYY")
                      )
                      : "",
                    polizaQualitas: patientQSelected?.polizaQualitas ?? null,
                  }));
                  setDateOfBirthday(
                    patientQSelected.dateOfBirthday
                      ? new Date(
                        moment(patientQSelected.dateOfBirthday, "DD-MM-YYYY")
                      )
                      : null
                  );
                  setOpenConfirmationQualitasPatients(false);
                }}
              >
                Aceptar
              </Button>
            </div>
            <div>
              <Button
                variant="outline-danger"
                type="button"
                onClick={() => {
                  setPolizaQualitas(null);
                  setOpenConfirmationQualitasPatients(false);
                  setErrorPoliza(false);
                  setInitialValues((prev) => ({
                    ...prev,
                    id: "",
                    account: "",
                    name: "",
                    middleName: "",
                    seccondSurname: prev.seccondSurname,
                    lastName: prev.lastName,
                    externalId: "",
                    dateOfBirthday: "",
                    email: "",
                    polizaQualitas: null,
                  }));
                }}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ComponentModalErrorSever
        show={showModalError}
        handleClose={handleCloseServer}
        error={errorServer}
      />
    </Row>
  );
}

export default withTranslation()(FormPatient);
